export const CarouselUXLMockJson = {
  searchPropertiesByKeyword: {
    total: 3,
    status: [
      {
        code: 'SUCCESS',
        httpStatus: 200,
        messages: [],
      },
    ],
    edges: [
      {
        node: {
          id: 'ABINE',
          basicInformation: {
            bookable: true,
            name: 'Courtyard Abilene Northeast',
            legalName: 'Courtyard® by Marriott® Abilene Northeast',
            brand: {
              id: 'CY',
              name: 'Courtyard',
            },
            resort: null,
            isAdultsOnly: null,
            newLobby: null,
            hasRenovatedRooms: null,
            isFullyRenovated: null,
            isRecentlyRenovated: null,
            newProperty: null,
          },
          contactInformation: {
            address: {
              city: 'Abilene',
              stateProvince: {
                code: 'TX',
                label: null,
                description: 'Texas',
              },
              country: {
                code: '1',
                label: null,
                description: 'USA',
              },
            },
          },
          media: {
            id: 'ABINE',
            primaryImage: {
              total: 1,
              edges: [
                {
                  node: {
                    caption: 'The Bistro Seating',
                    imageUrls: {
                      featureVertical:
                        '/is/image/marriotts7prod/cy-abine-the-bistro-seating-28212:Feature-Ver?wid=365&fit=constrain',
                      classicVertical:
                        '/is/image/marriotts7prod/cy-abine-the-bistro-seating-28212:Classic-Ver?wid=365&fit=constrain',
                      square: '/is/image/marriotts7prod/cy-abine-the-bistro-seating-28212:Square?wid=365&fit=constrain',
                    },
                    isPrimary: true,
                    title: 'The Bistro Seating 28212',
                  },
                },
              ],
            },
          },
          seoNickname: 'abine-courtyard-abilene-northeast',
        },
      },
      {
        node: {
          id: 'ABITS',
          basicInformation: {
            bookable: true,
            name: 'TownePlace Suites Abilene Northeast',
            legalName: 'TownePlace Suites by Marriott® Abilene Northeast',
            brand: {
              id: 'TP',
              name: 'TownePlace Suites',
            },
            resort: null,
            isAdultsOnly: null,
            newLobby: null,
            hasRenovatedRooms: null,
            isFullyRenovated: null,
            isRecentlyRenovated: null,
            newProperty: null,
          },
          contactInformation: {
            address: {
              city: 'Abilene',
              stateProvince: {
                code: 'TX',
                label: null,
                description: 'Texas',
              },
              country: {
                code: '1',
                label: null,
                description: 'USA',
              },
            },
          },
          media: {
            id: 'ABITS',
            primaryImage: {
              total: 1,
              edges: [
                {
                  node: {
                    caption: 'Communal Lounge',
                    imageUrls: {
                      featureVertical:
                        '/is/image/marriotts7prod/ts-abits-hotel-lobby-16703:Feature-Ver?wid=365&fit=constrain',
                      classicVertical:
                        '/is/image/marriotts7prod/ts-abits-hotel-lobby-16703:Classic-Ver?wid=365&fit=constrain',
                      square: '/is/image/marriotts7prod/ts-abits-hotel-lobby-16703:Square?wid=365&fit=constrain',
                    },
                    isPrimary: true,
                    title: 'Hotel Lobby-16703',
                  },
                },
              ],
            },
          },
          seoNickname: 'abits-towneplace-suites-abilene-northeast',
        },
      },
      {
        node: {
          id: 'AK',
          basicInformation: {
            bookable: true,
            legalName: 'The Buenaventura Golf & Beach Resort Panama, Autograph Collection®',
            name: 'The Buenaventura Golf & Beach Resort Panama, Autograph Collection',
            brand: {
              id: 'CY',
              name: 'Courtyard',
            },
            resort: null,
            isAdultsOnly: null,
            newLobby: null,
            hasRenovatedRooms: null,
            isFullyRenovated: null,
            isRecentlyRenovated: null,
            newProperty: null,
          },
          contactInformation: {
            address: {
              city: 'Riviera Pacifica',
              country: {
                __typename: 'Lookup',
                code: 'PA',
                description: 'Panama',
                label: null,
              },
              stateProvince: null,
            },
          },
          media: {
            id: 'PTYKP',
            primaryImage: {
              total: 1,
              edges: [
                {
                  node: {
                    caption: 'The Buenaventura Golf & Beach Resort Panama',
                    imageUrls: {
                      featureVertical:
                        '/is/image/marriotts7prod/mg-acybg-exterior-cropped-56296:Feature-Ver?wid=365&fit=constrain',
                      classicVertical:
                        '/is/image/marriotts7prod/mg-acybg-exterior-cropped-56296:Classic-Ver?wid=365&fit=constrain',
                      square: '/is/image/marriotts7prod/mg-acybg-exterior-cropped-56296:Square?wid=365&fit=constrain',
                    },
                    isPrimary: true,
                    title: 'The Buenaventura Golf & Beach Resort Panama',
                  },
                },
              ],
            },
          },
          seoNickname: 'ptykp-the-buenaventura-golf-and-beach-resort-panama-autograph-collection',
        },
      },
    ],
  },
  searchLowestAvailableRatesByGeolocation: {
    total: 3,
    status: [
      {
        code: 'SUCCESS',
        httpStatus: 200,
        messages: [],
      },
    ],
    edges: [
      {
        node: {
          id: 'ABINE',
          basicInformation: {
            bookable: true,
            name: 'Courtyard Abilene Northeast',
            legalName: 'Courtyard® by Marriott® Abilene Northeast',
            brand: {
              id: 'CY',
              name: 'Courtyard',
            },
            resort: null,
            isAdultsOnly: null,
            newLobby: null,
            hasRenovatedRooms: null,
            isFullyRenovated: null,
            isRecentlyRenovated: null,
            newProperty: null,
          },
          contactInformation: {
            address: {
              city: 'Abilene',
              stateProvince: {
                code: 'TX',
                label: null,
                description: 'Texas',
              },
              country: {
                code: '1',
                label: null,
                description: 'USA',
              },
            },
          },
          media: {
            id: 'ABINE',
            primaryImage: {
              total: 1,
              edges: [
                {
                  node: {
                    caption: 'The Bistro Seating',
                    imageUrls: {
                      featureVertical:
                        '/is/image/marriotts7prod/cy-abine-the-bistro-seating-28212:Feature-Ver?wid=365&fit=constrain',
                      classicVertical:
                        '/is/image/marriotts7prod/cy-abine-the-bistro-seating-28212:Classic-Ver?wid=365&fit=constrain',
                      square: '/is/image/marriotts7prod/cy-abine-the-bistro-seating-28212:Square?wid=365&fit=constrain',
                    },
                    isPrimary: true,
                    title: 'The Bistro Seating 28212',
                  },
                },
              ],
            },
          },
          seoNickname: 'abine-courtyard-abilene-northeast',
        },
      },
      {
        node: {
          id: 'ABITS',
          basicInformation: {
            bookable: true,
            name: 'TownePlace Suites Abilene Northeast',
            legalName: 'TownePlace Suites by Marriott® Abilene Northeast',
            brand: {
              id: 'TP',
              name: 'TownePlace Suites',
            },
            resort: null,
            isAdultsOnly: null,
            newLobby: null,
            hasRenovatedRooms: null,
            isFullyRenovated: null,
            isRecentlyRenovated: null,
            newProperty: null,
          },
          contactInformation: {
            address: {
              city: 'Abilene',
              stateProvince: {
                code: 'TX',
                label: null,
                description: 'Texas',
              },
              country: {
                code: '1',
                label: null,
                description: 'USA',
              },
            },
          },
          media: {
            id: 'ABITS',
            primaryImage: {
              total: 1,
              edges: [
                {
                  node: {
                    caption: 'Communal Lounge',
                    imageUrls: {
                      featureVertical:
                        '/is/image/marriotts7prod/ts-abits-hotel-lobby-16703:Feature-Ver?wid=365&fit=constrain',
                      classicVertical:
                        '/is/image/marriotts7prod/ts-abits-hotel-lobby-16703:Classic-Ver?wid=365&fit=constrain',
                      square: '/is/image/marriotts7prod/ts-abits-hotel-lobby-16703:Square?wid=365&fit=constrain',
                    },
                    isPrimary: true,
                    title: 'Hotel Lobby-16703',
                  },
                },
              ],
            },
          },
          seoNickname: 'abits-towneplace-suites-abilene-northeast',
        },
      },
      {
        node: {
          id: 'AK',
          basicInformation: {
            bookable: true,
            legalName: 'The Buenaventura Golf & Beach Resort Panama, Autograph Collection®',
            name: 'The Buenaventura Golf & Beach Resort Panama, Autograph Collection',
            brand: {
              id: 'CY',
              name: 'Courtyard',
            },
            resort: null,
            isAdultsOnly: null,
            newLobby: null,
            hasRenovatedRooms: null,
            isFullyRenovated: null,
            isRecentlyRenovated: null,
            newProperty: null,
          },
          contactInformation: {
            address: {
              city: 'Riviera Pacifica',
              country: {
                __typename: 'Lookup',
                code: 'PA',
                description: 'Panama',
                label: null,
              },
              stateProvince: null,
            },
          },
          media: {
            id: 'PTYKP',
            primaryImage: {
              total: 1,
              edges: [
                {
                  node: {
                    caption: 'The Buenaventura Golf & Beach Resort Panama',
                    imageUrls: {
                      featureVertical:
                        '/is/image/marriotts7prod/mg-acybg-exterior-cropped-56296:Feature-Ver?wid=365&fit=constrain',
                      classicVertical:
                        '/is/image/marriotts7prod/mg-acybg-exterior-cropped-56296:Classic-Ver?wid=365&fit=constrain',
                      square: '/is/image/marriotts7prod/mg-acybg-exterior-cropped-56296:Square?wid=365&fit=constrain',
                    },
                    isPrimary: true,
                    title: 'The Buenaventura Golf & Beach Resort Panama',
                  },
                },
              ],
            },
          },
          seoNickname: 'ptykp-the-buenaventura-golf-and-beach-resort-panama-autograph-collection',
        },
      },
    ],
  },
};
export const CarouselUXLMockJsonDTT = {
  search: {
    properties: {
      searchByGeolocation: {
        total: 222,
        edges: [
          {
            node: {
              id: 'NYCES',
              basicInformation: {
                name: 'Courtyard New York Manhattan/Fifth Avenue',
                legalName: 'Courtyard® by Marriott® New York Manhattan/Fifth Avenue',
                brand: {
                  id: 'CY',
                  name: 'Courtyard',
                  type: 'Marriott',
                  photos: [
                    {
                      content: [
                        {
                          index: 1,
                          name: 'cy-cy-lobby-pod-29210',
                          url: 'https://cache.marriott.com/is/image/marriotts7prod/cy-cy-lobby-pod-29210:Feature-Hor',
                          alternateText: 'Two women huddled at corner table working together',
                        },
                        {
                          index: 2,
                          name: 'cy-cy-business-breakfast-12963',
                          url: 'https://cache.marriott.com/is/image/marriotts7prod/cy-cy-business-breakfast-12963:Feature-Hor',
                          alternateText: 'Man eating breakfast while working.',
                        },
                        {
                          index: 3,
                          name: 'cy-main03-0001',
                          url: 'https://cache.marriott.com/content/dam/marriott-renditions/CY/cy-main03-0001-hor-feat.jpg',
                          alternateText: 'Courtyard Hotel Photo',
                        },
                      ],
                      type: {
                        code: 'primary',
                      },
                    },
                  ],
                },
                resort: false,
                isAdultsOnly: false,
                newLobby: false,
                hasRenovatedRooms: false,
                isFullyRenovated: false,
                isRecentlyRenovated: false,
                newProperty: false,
                bookable: true,
              },
              contactInformation: {
                address: {
                  city: 'New York',
                  stateProvince: {
                    code: 'NY',
                    label: null,
                    description: 'New York',
                  },
                  country: {
                    code: '1',
                    label: null,
                    description: 'USA',
                  },
                },
              },
              media: {
                id: 'NYCES',
                primaryImage: {
                  total: 1,
                  edges: [
                    {
                      node: {
                        caption: 'Queen/Queen Guest Room',
                        imageUrls: {
                          featureVertical: '',
                          classicVertical: '',
                          square: '/content/dam/marriott-renditions/NYCES/nyces-guestroom-0031-sq.jpg',
                        },
                        isPrimary: true,
                        title: 'nyces-guestroom-0031',
                      },
                    },
                  ],
                },
              },
              seoNickname: 'nyces-courtyard-new-york-manhattan-fifth-avenue',
            },
          },
        ],
        status: [
          {
            __typename: 'ResponseSuccess',
            code: 'SUCCESS',
            httpStatus: 200,
            errors: [],
            warnings: [
              {
                code: 'WARN-RATES-1002',
                devMessage: 'Invalid Start Or End Date Error From AMP',
                message: 'Invalid Start Or End Date Error From AMP',
                fields: [],
              },
            ],
          },
        ],
      },
      searchByKeyword: {
        total: 45,
        edges: [
          {
            node: {
              id: 'MSPOS',
              basicInformation: {
                name: 'Sheraton Bloomington Hotel',
                legalName: 'Sheraton Bloomington Hotel',
                brand: {
                  id: 'SI',
                  name: 'Sheraton',
                  type: 'SPG',
                  photos: [
                    {
                      content: [
                        {
                          index: 1,
                          name: 'si_main01',
                          url: 'https://cache.marriott.com/is/image/marriotts7prod/si-main-001-hor-clsc:Feature-Hor',
                          alternateText: 'Sheraton Hotel photography',
                        },
                        {
                          index: 2,
                          name: 'si_main02',
                          url: 'https://cache.marriott.com/content/dam/marriott-renditions/SI/si-main-002-hor-feat.jpg',
                          alternateText: 'Sheraton Hotel photography',
                        },
                        {
                          index: 3,
                          name: 'si_main03',
                          url: 'https://cache.marriott.com/content/dam/marriott-renditions/SI/si-main-003-hor-feat.jpg',
                          alternateText: 'Sheraton Hotel photography',
                        },
                      ],
                      type: {
                        code: 'primary',
                      },
                    },
                  ],
                },
                resort: false,
                isAdultsOnly: false,
                newLobby: false,
                hasRenovatedRooms: false,
                isFullyRenovated: false,
                isRecentlyRenovated: false,
                newProperty: false,
                bookable: true,
              },
              contactInformation: {
                address: {
                  city: 'Bloomington',
                  stateProvince: {
                    code: 'MN',
                    label: null,
                    description: 'Minnesota',
                  },
                  country: {
                    code: '1',
                    label: null,
                    description: 'USA',
                  },
                },
              },
              media: {
                id: 'MSPOS',
                primaryImage: {
                  total: 1,
                  edges: [
                    {
                      node: {
                        caption: 'Lobby Lounge',
                        imageUrls: {
                          featureVertical: '',
                          classicVertical: '',
                          square: '/content/dam/marriott-renditions/MSPOS/mspos-lobby-lounge-5680-sq.jpg',
                        },
                        isPrimary: true,
                        title: 'mspos-lobby-lounge-5680',
                      },
                    },
                  ],
                },
              },
              seoNickname: 'mspos-sheraton-bloomington-hotel',
            },
          },
        ],
        status: [
          {
            __typename: 'ResponseSuccess',
            code: 'SUCCESS',
            httpStatus: 200,
            errors: [],
            warnings: [
              {
                code: 'WARN-RATES-1002',
                devMessage: 'Invalid Start Or End Date Error From AMP',
                message: 'Invalid Start Or End Date Error From AMP',
                fields: [],
              },
            ],
          },
        ],
      },
    },
  },
};
export const CarouselUXLMockJsonBrands = {
  searchPropertiesByKeyword: {
    total: 49,
    status: [
      {
        code: 'SUCCESS',
        httpStatus: 200,
        messages: [],
        __typename: 'ResponseSuccess',
      },
    ],
    edges: [
      {
        node: {
          id: 'ATLXR',
          basicInformation: {
            name: 'The St. Regis Atlanta',
            legalName: 'The St. Regis Atlanta',
            brand: {
              id: 'XR',
              name: 'St. Regis',
              type: 'SPG',
              photos: [
                {
                  content: [
                    {
                      index: 1,
                      name: 'xr_main01',
                      url: 'https://cache.marriott.com/marriottassets/marriott/XR/xr-main-001-hor-feat.jpg',
                      alternateText: 'St. Regis photography',
                      __typename: 'BrandPhotoContent',
                    },
                    {
                      index: 2,
                      name: 'xr_main02',
                      url: 'https://cache.marriott.com/marriottassets/marriott/XR/xr-main-002-hor-feat.jpg',
                      alternateText: 'St. Regis photography',
                      __typename: 'BrandPhotoContent',
                    },
                    {
                      index: 3,
                      name: 'xr_main03',
                      url: 'https://cache.marriott.com/marriottassets/marriott/XR/xr-main-003-hor-feat.jpg',
                      alternateText: 'St. Regis photography',
                      __typename: 'BrandPhotoContent',
                    },
                  ],
                  type: {
                    code: 'primary',
                    __typename: 'Lookup',
                  },
                  __typename: 'BrandPhoto',
                },
              ],
              __typename: 'Brand',
            },
            resort: false,
            isAdultsOnly: false,
            newLobby: false,
            hasRenovatedRooms: false,
            isFullyRenovated: false,
            isRecentlyRenovated: false,
            newProperty: false,
            __typename: 'HotelBasicInformation',
            bookable: true,
          },
          contactInformation: {
            address: {
              city: 'Atlanta',
              stateProvince: {
                code: 'GA',
                label: null,
                description: 'Georgia',
                __typename: 'Lookup',
              },
              country: {
                code: 'US',
                label: null,
                description: 'USA',
                __typename: 'Lookup',
              },
              __typename: 'PropertyAddress',
            },
            __typename: 'PropertyContactInformation',
          },
          media: {
            id: 'ATLXR',
            primaryImage: {
              total: 1,
              edges: [
                {
                  node: {
                    caption: 'Exterior',
                    imageUrls: {
                      featureVertical: '',
                      classicVertical: '',
                      square: '/content/dam/marriott-renditions/ATLXR/atlxr-exterior-2642-sq.jpg',
                      __typename: 'ImageRendition',
                    },
                    isPrimary: true,
                    title: 'atlxr-exterior-2642',
                    __typename: 'ProductImage',
                  },
                  __typename: 'ProductImageConnectionEdge',
                },
              ],
              __typename: 'ProductImageConnection',
            },
            __typename: 'HotelMediaContent',
          },
          seoNickname: 'atlxr-the-st-regis-atlanta',
          __typename: 'Hotel',
        },
        __typename: 'PropertySearchEdge',
      },
      {
        node: {
          id: 'TUSRZ',
          basicInformation: {
            name: 'The Ritz-Carlton, Dove Mountain',
            legalName: '',
            brand: {
              id: 'RZ',
              name: 'The Ritz-Carlton',
              type: 'Marriott',
              photos: [
                {
                  content: [
                    {
                      index: 1,
                      name: 'rz_main01',
                      url: 'https://cache.marriott.com/marriottassets/marriott/RZ/rz-main01-0001-hor-feat.jpg',
                      alternateText: 'Ritz-Carlton Hotel',
                      __typename: 'BrandPhotoContent',
                    },
                  ],
                  type: {
                    code: 'primary',
                    __typename: 'Lookup',
                  },
                  __typename: 'BrandPhoto',
                },
              ],
              __typename: 'Brand',
            },
            resort: true,
            isAdultsOnly: false,
            newLobby: false,
            hasRenovatedRooms: false,
            isFullyRenovated: false,
            isRecentlyRenovated: false,
            newProperty: false,
            __typename: 'HotelBasicInformation',
            bookable: true,
          },
          contactInformation: {
            address: {
              city: 'Marana',
              stateProvince: {
                code: 'AZ',
                label: null,
                description: 'Arizona',
                __typename: 'Lookup',
              },
              country: {
                code: 'US',
                label: null,
                description: 'USA',
                __typename: 'Lookup',
              },
              __typename: 'PropertyAddress',
            },
            __typename: 'PropertyContactInformation',
          },
          media: {
            id: 'TUSRZ',
            primaryImage: {
              total: 1,
              edges: [
                {
                  node: {
                    caption: 'Pool Overview',
                    imageUrls: {
                      featureVertical: '',
                      classicVertical: '',
                      square: '/content/dam/marriott-renditions/TUSRZ/tusrz-sunrise-4341-sq.jpg',
                      __typename: 'ImageRendition',
                    },
                    isPrimary: true,
                    title: 'tusrz-sunrise-4341',
                    __typename: 'ProductImage',
                  },
                  __typename: 'ProductImageConnectionEdge',
                },
              ],
              __typename: 'ProductImageConnection',
            },
            __typename: 'HotelMediaContent',
          },
          seoNickname: 'tusrz-the-ritz-carlton-dove-mountain',
          __typename: 'Hotel',
        },
        __typename: 'PropertySearchEdge',
      },
      {
        node: {
          id: 'JHMRZ',
          basicInformation: {
            name: 'The Ritz-Carlton Maui, Kapalua',
            legalName: '',
            brand: {
              id: 'RZ',
              name: 'The Ritz-Carlton',
              type: 'Marriott',
              photos: [
                {
                  content: [
                    {
                      index: 1,
                      name: 'rz_main01',
                      url: 'https://cache.marriott.com/marriottassets/marriott/RZ/rz-main01-0001-hor-feat.jpg',
                      alternateText: 'Ritz-Carlton Hotel',
                      __typename: 'BrandPhotoContent',
                    },
                  ],
                  type: {
                    code: 'primary',
                    __typename: 'Lookup',
                  },
                  __typename: 'BrandPhoto',
                },
              ],
              __typename: 'Brand',
            },
            resort: true,
            isAdultsOnly: false,
            newLobby: false,
            hasRenovatedRooms: false,
            isFullyRenovated: false,
            isRecentlyRenovated: false,
            newProperty: false,
            __typename: 'HotelBasicInformation',
            bookable: true,
          },
          contactInformation: {
            address: {
              city: 'Kapalua',
              stateProvince: {
                code: 'HI',
                label: null,
                description: 'Hawaii',
                __typename: 'Lookup',
              },
              country: {
                code: 'US',
                label: null,
                description: 'USA',
                __typename: 'Lookup',
              },
              __typename: 'PropertyAddress',
            },
            __typename: 'PropertyContactInformation',
          },
          media: {
            id: 'JHMRZ',
            primaryImage: {
              total: 1,
              edges: [
                {
                  node: {
                    caption: 'Aerial View',
                    imageUrls: {
                      featureVertical: '',
                      classicVertical: '',
                      square: '/content/dam/marriott-renditions/JHMRZ/jhmrz-aerial-view-8918-sq.jpg',
                      __typename: 'ImageRendition',
                    },
                    isPrimary: true,
                    title: 'jhmrz-aerial-view-8918',
                    __typename: 'ProductImage',
                  },
                  __typename: 'ProductImageConnectionEdge',
                },
              ],
              __typename: 'ProductImageConnection',
            },
            __typename: 'HotelMediaContent',
          },
          seoNickname: 'jhmrz-the-ritz-carlton-maui-kapalua',
          __typename: 'Hotel',
        },
        __typename: 'PropertySearchEdge',
      },
      {
        node: {
          id: 'CHIXR',
          basicInformation: {
            name: 'The St. Regis Chicago',
            legalName: 'The St. Regis Chicago',
            brand: {
              id: 'XR',
              name: 'St. Regis',
              type: 'SPG',
              photos: [
                {
                  content: [
                    {
                      index: 1,
                      name: 'xr_main01',
                      url: 'https://cache.marriott.com/marriottassets/marriott/XR/xr-main-001-hor-feat.jpg',
                      alternateText: 'St. Regis photography',
                      __typename: 'BrandPhotoContent',
                    },
                    {
                      index: 2,
                      name: 'xr_main02',
                      url: 'https://cache.marriott.com/marriottassets/marriott/XR/xr-main-002-hor-feat.jpg',
                      alternateText: 'St. Regis photography',
                      __typename: 'BrandPhotoContent',
                    },
                    {
                      index: 3,
                      name: 'xr_main03',
                      url: 'https://cache.marriott.com/marriottassets/marriott/XR/xr-main-003-hor-feat.jpg',
                      alternateText: 'St. Regis photography',
                      __typename: 'BrandPhotoContent',
                    },
                  ],
                  type: {
                    code: 'primary',
                    __typename: 'Lookup',
                  },
                  __typename: 'BrandPhoto',
                },
              ],
              __typename: 'Brand',
            },
            resort: false,
            isAdultsOnly: false,
            newLobby: false,
            hasRenovatedRooms: false,
            isFullyRenovated: false,
            isRecentlyRenovated: false,
            newProperty: false,
            __typename: 'HotelBasicInformation',
            bookable: true,
          },
          contactInformation: {
            address: {
              city: 'Chicago',
              stateProvince: {
                code: 'IL',
                label: null,
                description: 'Illinois',
                __typename: 'Lookup',
              },
              country: {
                code: 'US',
                label: null,
                description: 'USA',
                __typename: 'Lookup',
              },
              __typename: 'PropertyAddress',
            },
            __typename: 'PropertyContactInformation',
          },
          media: {
            id: 'CHIXR',
            primaryImage: {
              total: 1,
              edges: [
                {
                  node: {
                    caption: 'Exterior',
                    imageUrls: {
                      featureVertical: '',
                      classicVertical: '',
                      square: '/content/dam/marriott-renditions/CHIXR/chixr-exterior-6021-sq.jpg',
                      __typename: 'ImageRendition',
                    },
                    isPrimary: true,
                    title: 'chixr-exterior-6021',
                    __typename: 'ProductImage',
                  },
                  __typename: 'ProductImageConnectionEdge',
                },
              ],
              __typename: 'ProductImageConnection',
            },
            __typename: 'HotelMediaContent',
          },
          seoNickname: 'chixr-the-st-regis-chicago',
          __typename: 'Hotel',
        },
        __typename: 'PropertySearchEdge',
      },
      {
        node: {
          id: 'HAFRZ',
          basicInformation: {
            name: 'The Ritz-Carlton, Half Moon Bay',
            legalName: '',
            brand: {
              id: 'RZ',
              name: 'The Ritz-Carlton',
              type: 'Marriott',
              photos: [
                {
                  content: [
                    {
                      index: 1,
                      name: 'rz_main01',
                      url: 'https://cache.marriott.com/marriottassets/marriott/RZ/rz-main01-0001-hor-feat.jpg',
                      alternateText: 'Ritz-Carlton Hotel',
                      __typename: 'BrandPhotoContent',
                    },
                  ],
                  type: {
                    code: 'primary',
                    __typename: 'Lookup',
                  },
                  __typename: 'BrandPhoto',
                },
              ],
              __typename: 'Brand',
            },
            resort: true,
            isAdultsOnly: false,
            newLobby: false,
            hasRenovatedRooms: false,
            isFullyRenovated: false,
            isRecentlyRenovated: false,
            newProperty: false,
            __typename: 'HotelBasicInformation',
            bookable: true,
          },
          contactInformation: {
            address: {
              city: 'Half Moon Bay',
              stateProvince: {
                code: 'CA',
                label: null,
                description: 'California',
                __typename: 'Lookup',
              },
              country: {
                code: 'US',
                label: null,
                description: 'USA',
                __typename: 'Lookup',
              },
              __typename: 'PropertyAddress',
            },
            __typename: 'PropertyContactInformation',
          },
          media: {
            id: 'HAFRZ',
            primaryImage: {
              total: 1,
              edges: [
                {
                  node: {
                    caption: 'Shoreline',
                    imageUrls: {
                      featureVertical: '/is/image/marriotts7prod/rz-hafrz-shoreline-10197:Feature-Ver',
                      classicVertical: '/is/image/marriotts7prod/rz-hafrz-shoreline-10197:Classic-Ver',
                      square: '/is/image/marriotts7prod/rz-hafrz-shoreline-10197:Square',
                      __typename: 'ImageRendition',
                    },
                    isPrimary: true,
                    title: 'shoreline-10197',
                    __typename: 'ProductImage',
                  },
                  __typename: 'ProductImageConnectionEdge',
                },
              ],
              __typename: 'ProductImageConnection',
            },
            __typename: 'HotelMediaContent',
          },
          seoNickname: 'hafrz-the-ritz-carlton-half-moon-bay',
          __typename: 'Hotel',
        },
        __typename: 'PropertySearchEdge',
      },
      {
        node: {
          id: 'DALIL',
          basicInformation: {
            name: 'The Ritz-Carlton Dallas, Las Colinas',
            legalName: '',
            brand: {
              id: 'RZ',
              name: 'The Ritz-Carlton',
              type: 'Marriott',
              photos: [
                {
                  content: [
                    {
                      index: 1,
                      name: 'rz_main01',
                      url: 'https://cache.marriott.com/marriottassets/marriott/RZ/rz-main01-0001-hor-feat.jpg',
                      alternateText: 'Ritz-Carlton Hotel',
                      __typename: 'BrandPhotoContent',
                    },
                  ],
                  type: {
                    code: 'primary',
                    __typename: 'Lookup',
                  },
                  __typename: 'BrandPhoto',
                },
              ],
              __typename: 'Brand',
            },
            resort: false,
            isAdultsOnly: false,
            newLobby: false,
            hasRenovatedRooms: false,
            isFullyRenovated: false,
            isRecentlyRenovated: false,
            newProperty: false,
            __typename: 'HotelBasicInformation',
            bookable: true,
          },
          contactInformation: {
            address: {
              city: 'Irving',
              stateProvince: {
                code: 'TX',
                label: null,
                description: 'Texas',
                __typename: 'Lookup',
              },
              country: {
                code: 'US',
                label: null,
                description: 'USA',
                __typename: 'Lookup',
              },
              __typename: 'PropertyAddress',
            },
            __typename: 'PropertyContactInformation',
          },
          media: {
            id: 'DALIL',
            primaryImage: {
              total: 1,
              edges: [
                {
                  node: {
                    caption: 'Resosrt HERO',
                    imageUrls: {
                      featureVertical: '/is/image/marriotts7prod/rz-dalil-resort-hero-30418:Feature-Ver',
                      classicVertical: '/is/image/marriotts7prod/rz-dalil-resort-hero-30418:Classic-Ver',
                      square: '/is/image/marriotts7prod/rz-dalil-resort-hero-30418:Square',
                      __typename: 'ImageRendition',
                    },
                    isPrimary: true,
                    title: 'Resort HERO 30418',
                    __typename: 'ProductImage',
                  },
                  __typename: 'ProductImageConnectionEdge',
                },
              ],
              __typename: 'ProductImageConnection',
            },
            __typename: 'HotelMediaContent',
          },
          seoNickname: 'dalil-the-ritz-carlton-dallas-las-colinas',
          __typename: 'Hotel',
        },
        __typename: 'PropertySearchEdge',
      },
      {
        node: {
          id: 'RSWRZ',
          basicInformation: {
            name: 'The Ritz-Carlton, Naples',
            legalName: '',
            brand: {
              id: 'RZ',
              name: 'The Ritz-Carlton',
              type: 'Marriott',
              photos: [
                {
                  content: [
                    {
                      index: 1,
                      name: 'rz_main01',
                      url: 'https://cache.marriott.com/marriottassets/marriott/RZ/rz-main01-0001-hor-feat.jpg',
                      alternateText: 'Ritz-Carlton Hotel',
                      __typename: 'BrandPhotoContent',
                    },
                  ],
                  type: {
                    code: 'primary',
                    __typename: 'Lookup',
                  },
                  __typename: 'BrandPhoto',
                },
              ],
              __typename: 'Brand',
            },
            resort: true,
            isAdultsOnly: false,
            newLobby: false,
            hasRenovatedRooms: false,
            isFullyRenovated: false,
            isRecentlyRenovated: false,
            newProperty: false,
            __typename: 'HotelBasicInformation',
            bookable: true,
          },
          contactInformation: {
            address: {
              city: 'Naples',
              stateProvince: {
                code: 'FL',
                label: null,
                description: 'Florida',
                __typename: 'Lookup',
              },
              country: {
                code: 'US',
                label: null,
                description: 'USA',
                __typename: 'Lookup',
              },
              __typename: 'PropertyAddress',
            },
            __typename: 'PropertyContactInformation',
          },
          media: {
            id: 'RSWRZ',
            primaryImage: {
              total: 1,
              edges: [
                {
                  node: {
                    caption: 'Hotel Exterior',
                    imageUrls: {
                      featureVertical: '/is/image/marriotts7prod/rz-rswrz-exterior-beach-18868:Feature-Ver',
                      classicVertical: '/is/image/marriotts7prod/rz-rswrz-exterior-beach-18868:Classic-Ver',
                      square: '/is/image/marriotts7prod/rz-rswrz-exterior-beach-18868:Square',
                      __typename: 'ImageRendition',
                    },
                    isPrimary: true,
                    title: 'exterior-beach',
                    __typename: 'ProductImage',
                  },
                  __typename: 'ProductImageConnectionEdge',
                },
              ],
              __typename: 'ProductImageConnection',
            },
            __typename: 'HotelMediaContent',
          },
          seoNickname: 'rswrz-the-ritz-carlton-naples',
          __typename: 'Hotel',
        },
        __typename: 'PropertySearchEdge',
      },
      {
        node: {
          id: 'PSPPS',
          basicInformation: {
            name: 'The Ritz-Carlton, Rancho Mirage',
            legalName: '',
            brand: {
              id: 'RZ',
              name: 'The Ritz-Carlton',
              type: 'Marriott',
              photos: [
                {
                  content: [
                    {
                      index: 1,
                      name: 'rz_main01',
                      url: 'https://cache.marriott.com/marriottassets/marriott/RZ/rz-main01-0001-hor-feat.jpg',
                      alternateText: 'Ritz-Carlton Hotel',
                      __typename: 'BrandPhotoContent',
                    },
                  ],
                  type: {
                    code: 'primary',
                    __typename: 'Lookup',
                  },
                  __typename: 'BrandPhoto',
                },
              ],
              __typename: 'Brand',
            },
            resort: true,
            isAdultsOnly: false,
            newLobby: false,
            hasRenovatedRooms: false,
            isFullyRenovated: false,
            isRecentlyRenovated: false,
            newProperty: false,
            __typename: 'HotelBasicInformation',
            bookable: true,
          },
          contactInformation: {
            address: {
              city: 'Rancho Mirage',
              stateProvince: {
                code: 'CA',
                label: null,
                description: 'California',
                __typename: 'Lookup',
              },
              country: {
                code: 'US',
                label: null,
                description: 'USA',
                __typename: 'Lookup',
              },
              __typename: 'PropertyAddress',
            },
            __typename: 'PropertyContactInformation',
          },
          media: {
            id: 'PSPPS',
            primaryImage: {
              total: 1,
              edges: [
                {
                  node: {
                    caption: 'Retreat to Rancho Mirage',
                    imageUrls: {
                      featureVertical: '/is/image/marriotts7prod/rz-pspps-pspps-hote-image-drone-25400:Feature-Ver',
                      classicVertical: '/is/image/marriotts7prod/rz-pspps-pspps-hote-image-drone-25400:Classic-Ver',
                      square: '/is/image/marriotts7prod/rz-pspps-pspps-hote-image-drone-25400:Square',
                      __typename: 'ImageRendition',
                    },
                    isPrimary: true,
                    title: 'PSPPS_Hote_Image_Drone',
                    __typename: 'ProductImage',
                  },
                  __typename: 'ProductImageConnectionEdge',
                },
              ],
              __typename: 'ProductImageConnection',
            },
            __typename: 'HotelMediaContent',
          },
          seoNickname: 'pspps-the-ritz-carlton-rancho-mirage',
          __typename: 'Hotel',
        },
        __typename: 'PropertySearchEdge',
      },
      {
        node: {
          id: 'HNLRR',
          basicInformation: {
            name: 'The Ritz-Carlton Residences, Waikiki Beach',
            legalName: 'The Ritz-Carlton Residences, Waikiki Beach',
            brand: {
              id: 'RZ',
              name: 'The Ritz-Carlton',
              type: 'Marriott',
              photos: [
                {
                  content: [
                    {
                      index: 1,
                      name: 'rz_main01',
                      url: 'https://cache.marriott.com/marriottassets/marriott/RZ/rz-main01-0001-hor-feat.jpg',
                      alternateText: 'Ritz-Carlton Hotel',
                      __typename: 'BrandPhotoContent',
                    },
                  ],
                  type: {
                    code: 'primary',
                    __typename: 'Lookup',
                  },
                  __typename: 'BrandPhoto',
                },
              ],
              __typename: 'Brand',
            },
            resort: false,
            isAdultsOnly: false,
            newLobby: false,
            hasRenovatedRooms: false,
            isFullyRenovated: false,
            isRecentlyRenovated: false,
            newProperty: false,
            __typename: 'HotelBasicInformation',
            bookable: true,
          },
          contactInformation: {
            address: {
              city: 'Waikiki Beach',
              stateProvince: {
                code: 'HI',
                label: null,
                description: 'Hawaii',
                __typename: 'Lookup',
              },
              country: {
                code: 'US',
                label: null,
                description: 'USA',
                __typename: 'Lookup',
              },
              __typename: 'PropertyAddress',
            },
            __typename: 'PropertyContactInformation',
          },
          media: {
            id: 'HNLRR',
            primaryImage: {
              total: 1,
              edges: [
                {
                  node: {
                    caption: 'Adult Pool Overlooking City',
                    imageUrls: {
                      featureVertical: '/is/image/marriotts7prod/rz-hnlrr-adult-pool-overlooking-ci-41471:Feature-Ver',
                      classicVertical: '/is/image/marriotts7prod/rz-hnlrr-adult-pool-overlooking-ci-41471:Classic-Ver',
                      square: '/is/image/marriotts7prod/rz-hnlrr-adult-pool-overlooking-ci-41471:Square',
                      __typename: 'ImageRendition',
                    },
                    isPrimary: true,
                    title: 'Adult Pool Overlooking Ci',
                    __typename: 'ProductImage',
                  },
                  __typename: 'ProductImageConnectionEdge',
                },
              ],
              __typename: 'ProductImageConnection',
            },
            __typename: 'HotelMediaContent',
          },
          seoNickname: 'hnlrr-the-ritz-carlton-residences-waikiki-beach',
          __typename: 'Hotel',
        },
        __typename: 'PropertySearchEdge',
      },
      {
        node: {
          id: 'CLTRZ',
          basicInformation: {
            name: 'The Ritz-Carlton, Charlotte',
            legalName: '',
            brand: {
              id: 'RZ',
              name: 'The Ritz-Carlton',
              type: 'Marriott',
              photos: [
                {
                  content: [
                    {
                      index: 1,
                      name: 'rz_main01',
                      url: 'https://cache.marriott.com/marriottassets/marriott/RZ/rz-main01-0001-hor-feat.jpg',
                      alternateText: 'Ritz-Carlton Hotel',
                      __typename: 'BrandPhotoContent',
                    },
                  ],
                  type: {
                    code: 'primary',
                    __typename: 'Lookup',
                  },
                  __typename: 'BrandPhoto',
                },
              ],
              __typename: 'Brand',
            },
            resort: false,
            isAdultsOnly: false,
            newLobby: false,
            hasRenovatedRooms: false,
            isFullyRenovated: false,
            isRecentlyRenovated: false,
            newProperty: false,
            __typename: 'HotelBasicInformation',
            bookable: true,
          },
          contactInformation: {
            address: {
              city: 'Charlotte',
              stateProvince: {
                code: 'NC',
                label: null,
                description: 'North Carolina',
                __typename: 'Lookup',
              },
              country: {
                code: 'US',
                label: null,
                description: 'USA',
                __typename: 'Lookup',
              },
              __typename: 'PropertyAddress',
            },
            __typename: 'PropertyContactInformation',
          },
          media: {
            id: 'CLTRZ',
            primaryImage: {
              total: 1,
              edges: [
                {
                  node: {
                    caption: 'Hotel Exterior',
                    imageUrls: {
                      featureVertical: '',
                      classicVertical: '',
                      square: '/content/dam/marriott-renditions/CLTRZ/cltrz-exterior-0008-sq.jpg',
                      __typename: 'ImageRendition',
                    },
                    isPrimary: true,
                    title: 'cltrz-exterior-0008',
                    __typename: 'ProductImage',
                  },
                  __typename: 'ProductImageConnectionEdge',
                },
              ],
              __typename: 'ProductImageConnection',
            },
            __typename: 'HotelMediaContent',
          },
          seoNickname: 'cltrz-the-ritz-carlton-charlotte',
          __typename: 'Hotel',
        },
        __typename: 'PropertySearchEdge',
      },
      {
        node: {
          id: 'MIASB',
          basicInformation: {
            name: 'The Ritz-Carlton, South Beach',
            legalName: '',
            brand: {
              id: 'RZ',
              name: 'The Ritz-Carlton',
              type: 'Marriott',
              photos: [
                {
                  content: [
                    {
                      index: 1,
                      name: 'rz_main01',
                      url: 'https://cache.marriott.com/marriottassets/marriott/RZ/rz-main01-0001-hor-feat.jpg',
                      alternateText: 'Ritz-Carlton Hotel',
                      __typename: 'BrandPhotoContent',
                    },
                  ],
                  type: {
                    code: 'primary',
                    __typename: 'Lookup',
                  },
                  __typename: 'BrandPhoto',
                },
              ],
              __typename: 'Brand',
            },
            resort: true,
            isAdultsOnly: false,
            newLobby: false,
            hasRenovatedRooms: false,
            isFullyRenovated: false,
            isRecentlyRenovated: false,
            newProperty: false,
            __typename: 'HotelBasicInformation',
            bookable: true,
          },
          contactInformation: {
            address: {
              city: 'Miami Beach',
              stateProvince: {
                code: 'FL',
                label: null,
                description: 'Florida',
                __typename: 'Lookup',
              },
              country: {
                code: 'US',
                label: null,
                description: 'USA',
                __typename: 'Lookup',
              },
              __typename: 'PropertyAddress',
            },
            __typename: 'PropertyContactInformation',
          },
          media: {
            id: 'MIASB',
            primaryImage: {
              total: 1,
              edges: [
                {
                  node: {
                    caption: 'Outdoor Pool',
                    imageUrls: {
                      featureVertical: '',
                      classicVertical: '',
                      square: '/content/dam/marriott-renditions/MIASB/miasb-pool-3855-sq.jpg',
                      __typename: 'ImageRendition',
                    },
                    isPrimary: true,
                    title: 'miasb-pool-3855',
                    __typename: 'ProductImage',
                  },
                  __typename: 'ProductImageConnectionEdge',
                },
              ],
              __typename: 'ProductImageConnection',
            },
            __typename: 'HotelMediaContent',
          },
          seoNickname: 'miasb-the-ritz-carlton-south-beach',
          __typename: 'Hotel',
        },
        __typename: 'PropertySearchEdge',
      },
    ],
    __typename: 'PropertySearchConnectionByKeyword',
  },
};
